import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { ActionsService } from '../services/actions.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DateService } from '../services/date.service';
import { NgForm } from '@angular/forms';
import { RechercheComponent } from '../recherche/recherche.component';
import { AvtListeMachineComponent } from '../avt-liste-machine/avt-liste-machine.component';
import { CalendarComponent } from '../calendar/calendar.component';

@Component({
  selector: 'app-avt-machine-reservation',
  templateUrl: './avt-machine-reservation.component.html',
  styleUrls: ['./avt-machine-reservation.component.scss']
})
export class AvtMachineReservationComponent implements OnInit
{
  constructor(public dialog : MatDialog,public generalService : GeneralService, public actionsService : ActionsService,public dateService : DateService) { }
  @ViewChild("calendarReservationComponent", {static : false}) calendarReservationComponent :CalendarComponent;
  @ViewChild("fenetterModaleReservationEquipememt", {static : false}) fenetterModaleReservationEquipememt
  @ViewChild("rechercheMachine", {static : false}) rechercheMachine : RechercheComponent
  @ViewChild("collaborateurComponent", {static : false}) collaborateurComponent : RechercheComponent
  listeMachine_Type = []// [{text:"Réservation véhicule",value:1},{text:"Réservation équipement multimédia",value:2},{text:"Réservation équipement industriel",value:3},{text:"Réservation salle / atelier",value:4},]
  machineOrSalle = '1';
  reservation
  // pour connetre si on prend on considération des heures du matin ou non
  MatinChecked : boolean = false

  // pour connetre si on prend on considération des heures du apré midie ou non
  ApMidiChecked : boolean = false

  // pour disabled Bouton Enregister aprer click
  disabledBtn : boolean = false
  disabled : boolean = false

  //pour le composons d'edition de text
  // Angular Editor Supprimer
  // editorConfig = this.generalService.editorConfig;
  
  nbrPlace = [{text:"1 à 10",value:1},{text:"10 à 20",value:2},{text:"20 à 30",value:3},{text:">30",value:4}];

  // pour afficher ou masquer la barre de chargement du fenetre principale
  exist : boolean = false;
  // pour afficher ou masquer la barre de chargement du fenetre modale
  exist2 : boolean = true;
  
  //ds reservation equipement
  dsReservation

  //liste des reservation qui represente des evennet dans le calendrier
  eventsCalandar = []

  //paramtre heur (se trouve dans le menu des paramatre de l'application)
  paramHeure

  showCalendarReservation : boolean = false;

  // date debut d'affichage dans le calandrier
  dateDebutAffichageCalendar = new Date()

  // indentifian de l'evennement crée aprés selection
  compteur : number = 0;

  // liste reservation pour la date de debur et fin du calendrier
  listeReservation = [];

  timeAm = [];
  timePm = [];
  filterdTimeAm = [];
  filterdTimePm = [];
  listeCollaborateurs = [];
  paramAppRecherche={param : "1",param2 : "1",recherche:"Machineft",placeholder:"Équipement"};
  placeholderMachine = "Équipements";
  machineName = "";
  ngOnInit() 
  {
    this.reservation = {};
    // Angular Editor Supprimer
    // this.editorConfig.height = '100px';
    this.getDsReservation();
    // this.listeMachine_Type= this.listeMachine_Type.concat(this.generalService.listeMachine_Type,[{text:"Salles / Ateliers",value:5}])
    this.listeMachine_Type= this.listeMachine_Type.concat(this.generalService.listeMachine_Type,[])
 
    this.getCollaborateur()
  }
  getCollaborateur()
  {
    this.generalService.rechercheTable(this.generalService.url+"avtperso&param=0").subscribe(data =>
    {
      this.listeCollaborateurs = this.generalService.sort(data,"Perso_Nom")
    })
  }
  
  blurCollaborateur(event)
  {
    this.reservation.Perso_Matricule = event;
  }
  openListeMachine()
  {
    var listeCode :string = ""
    if(this.listeReservation.length>0)
    {
      listeCode = this.listeReservation.map(res =>{return res.Machine_Code}).reduce((a,b)=>{return a+";"+b});
      listeCode = ";" + listeCode + ";" ;
    }
    this.generalService.machineChoisie = "";
    this.generalService.fenetreAvtListeMachine = (this.reservation.Machine_Type == "5" ? "2" : "1");
    this.generalService.fenetreAvtListeMachineFilter =  (this.reservation.Machine_Type == "5" ? 
    (machine)=>
    {
      //[{text:"1 à 10",value:1},{text:"10 à 20",value:2},{text:"20 à 30",value:3},{text:">30",value:4}];
      var condition = true;
      if(this.reservation.nbrPlace)
      {
        if(this.reservation.nbrPlace == 1)
          condition = machine.Machine_TR < 11;
        else if(this.reservation.nbrPlace == 2)
          condition = machine.Machine_TR < 21 && machine.Machine_TR > 9;
        else if(this.reservation.nbrPlace == 3)
          condition = machine.Machine_TR < 31 && machine.Machine_TR > 20;
        if(this.reservation.nbrPlace == 4)
          condition = machine.Machine_TR > 30;
      }
      return listeCode.indexOf(";" +machine.Machine_Code + ";") ==-1 && condition;
    } : 
    (machine)=>{return listeCode.indexOf(";" +machine.Machine_Code + ";") ==-1});
    this.generalService.dialogOpend = this.generalService.dialog.open(AvtListeMachineComponent, new MatDialogConfig());
    
    this.generalService.dialogOpend.afterClosed().subscribe(() =>
    {
      this.generalService.fenetreAvtListeMachineFilter = null;
      if( this.generalService.isNotEmpty( this.generalService.machineChoisie))
      {
        this.exist = false;
         if(this.reservation.Machine_Type == 5)
          this.machineName ="Batiment: " + this.generalService.machineChoisie.Batiment+ " étage: " + this.generalService.machineChoisie.etage+ " porte: " + this.generalService.machineChoisie.numPort
        else
          this.machineName = this.generalService.machineChoisie.type+ " " + this.generalService.machineChoisie.numSerie+ " " + this.generalService.machineChoisie.detaile
        this.reservation.Machine_Code = this.generalService.machineChoisie.Machine_Code
      }
    });
  }
  listeMachine_TypeChange()
  {
    if(this.reservation.Machine_Type!= 5)
    {
      this.paramAppRecherche.param = "1";
      this.paramAppRecherche.param2 = this.reservation.Machine_Type
      this.placeholderMachine = "Équipements";
    }
    else
    {
      this.paramAppRecherche.param = "2"
      this.placeholderMachine = "Salles / Ateliers"
    }
    this.machineName = ""
    this.reservation.Machine_Code = null;
    this.rechercheMachine.valueColonneToReturn = null;
    this.rechercheMachine.parentVal = null;
  }
  // get from server la liste des reservation selon la date afficher dans la calendrirer
  geteListeReservationByDate()
  {
    this.exist = false;
    setTimeout(()=>
    {
      var calendar = this.calendarReservationComponent.calendarComponent;//.getApi();
      var dateDebut = this.dateService.setFormatDateRechercheServer(calendar.view.activeStart)
      var dateFin = this.dateService.setFormatDateRechercheServer(calendar.view.activeEnd)
      this.generalService.rechercheTable(this.generalService.url + "avtReservationEquipList&param="+dateDebut+","+dateFin).subscribe(data =>
      {
        this.listeReservation = data;
        this.createEventCalendar();
        this.exist = true;
      })
    },100)
    
  }
  //crée des evennement
  createEvent(listeEvent)
  {
    var events = [];
    listeEvent.forEach(reservation => 
    {
      var colorEvent = "rgb(43, 123, 170)"
      if(reservation.Perso_Matricule == this.generalService.collaborateurConnecter)
        colorEvent = "rgb(43, 170, 49)"
      if(this.generalService.isNotEmpty(reservation.HeureDebutAm) && reservation.HeureDebutAm != "00:00:00.0000000"&& reservation.HeureDebutAm != "00:00")
      {
        var eventAM = this.actionsService.createEvent(reservation,reservation.Machine_Lib +"<br>"+reservation.commentaire,reservation.id + "_AM",new Date(this.dateService.setToFormatDateServerStr(reservation.DateDebut) + " " + reservation.HeureDebutAm),new Date(this.dateService.setToFormatDateServerStr(reservation.DateDebut) + " " + reservation.HeureFinAm),colorEvent.repeat(1),"rgb(255, 255, 255)",null,false)
        events.push(eventAM);
      }
      if(this.generalService.isNotEmpty(reservation.HeureDebutPm) && reservation.HeureDebutPm != "00:00:00.0000000"&& reservation.HeureDebutPm != "00:00")
      {
        var eventPM = this.actionsService.createEvent(reservation,reservation.Machine_Lib +"<br>"+reservation.commentaire,reservation.id + "_PM",new Date(this.dateService.setToFormatDateServerStr(reservation.DateDebut) + " " + reservation.HeureDebutPm),new Date(this.dateService.setToFormatDateServerStr(reservation.DateDebut) + " " + reservation.HeureFinPm),colorEvent.repeat(1),"rgb(255, 255, 255)",null,false)
        events.push(eventPM);
      }
    });
    return events
  }
  //crée les evennement et les afficher dans le composent calandar depui la liste des reservation
  createEventCalendar()
  {
    var events = this.createEvent(this.listeReservation);
    
    if(events.length>0)
      this.calendarReservationComponent.setEventCalandar(events);
  }
  //opent Form Add New Reservation
  opentFrmAddNewReservation()
  {
    //pour corriger l'erreur du fonction dateservise.dateDif
    this.reservation.DateDebut = new Date()
    this.reservation.DateFin = new Date()
    this.dialog.open(this.fenetterModaleReservationEquipememt, new MatDialogConfig());
    this.reservation.Machine_Type = 1;
  }
  //close Form Reservation Equipememt
  closeFrmReservationEquipememt()
  {
    this.dialog.closeAll()
  }
  // get from server ds reservation equipement
  getDsReservation()
  {
    this.generalService.rechercheTable("ds/formdata?code=avtReservationEquip").subscribe(data => 
    {
      this.dsReservation = data;
      this.reservation = this.dsReservation.avtReservationEquip[0];
      this.getParamHeur();
    })
  }
  //  se declanche losque la reservation d'équipement change
  ChampEnterEquipement(event)
  {
    this.reservation.Machine_Code = event;
  }

  // verifier Disponibiliter Reservation Et Enregistrement Reservation
  verifierDisponibiliterReservationEtEnregistrer(formReservationEquipememt : NgForm)
  {
    if(formReservationEquipememt.valid && this.generalService.isNotEmpty(this.collaborateurComponent.valueColonneToReturn)&& this.generalService.isNotEmpty(this.reservation.Machine_Code))
    {
    var dateDebutReservation = this.dateService.setFormatDateRechercheServer(this.reservation.DateDebut);
    var dateFinReservation = this.dateService.setFormatDateRechercheServer(this.reservation.DateFin);
    this.generalService.rechercheTable(this.generalService.url + "avtReservationEquipList&param="+dateDebutReservation + "," + dateFinReservation).subscribe(data =>
    {
      if(this.verifierDisponibiliterReservation(data))
      {
        this.enregistrerReservation()
      }
      else
      this.generalService.dialogSuccess("Veuillez vérifier la disponibilité du matériel choisie dans l'intérvale du temps sélectionner ",false)
    })
    }
  }
  enregistrerReservation()
  {
    var nbrJourReservation = this.dateService.dateDiff(new Date(this.reservation.DateDebut),new Date(this.reservation.DateFin))
    this.exist2 = false;
    this.disabledBtn = true;
    var compt = this.dateService.dateDiff(this.reservation.DateDebut,this.reservation.DateFin)
    let j = 0
    for(let i=0; i< nbrJourReservation; i++)
    {
      if(i != 0)
        j = 1;
      var dateReservation = new Date(this.reservation.DateDebut);
      dateReservation.setDate(dateReservation.getDate()+j)
      this.reservation.DateDebut = this.dateService.setToFormatDateServerStr(dateReservation);
      this.reservation.DateFin = this.dateService.setToFormatDateServerStr(dateReservation);
      this.generalService.enregisterTable(this.dsReservation).subscribe(data => 
      {
        compt--;
        if(compt == 0)
        {
          this.exist2 = true;
          this.disabledBtn = false;
          this.geteListeReservationByDate()
        }
        this.generalService.dialogSuccess("enregistré", true)
      },
      ()=>
      {
        this.exist2 = true;
        this.disabledBtn = false;
        this.generalService.dialogSuccess("Non enregistré", false)
      })
    }
  }
  verifierDisponibiliterReservation(listeReservation) : boolean
  {
    var listeEvent = this.createEvent(listeReservation.filter(reservation => {return reservation.Machine_Code == this.reservation.Machine_Code}));
      //this.actionsService.createEvent(reservation,reservation.Machine_Lib,reservation.id + "_AM",new Date(this.dateService.setToFormatDateServerStr(reservation.DateDebut) + " " + reservation.HeureDebutAm),new Date(this.dateService.setToFormatDateServerStr(reservation.DateDebut) + " " + reservation.HeureFinAm),colorEvent.repeat(1),"rgb(255, 255, 255)",null,false)
    var eventReservationAm;
    var eventReservationPm;
    
    var disponible : boolean = true;
    var nbrJourReservation = this.dateService.dateDiff(this.reservation.DateDebut,this.reservation.DateFin)
    for(var i=0; i< nbrJourReservation; i++)
    {
      var dateReservation = new Date(this.reservation.DateDebut);
      dateReservation.setDate(dateReservation.getDate()+i)
      if(this.MatinChecked)
        eventReservationAm = this.actionsService.createEvent(this.reservation,"",this.reservation.id + "_AM",new Date(this.dateService.setToFormatDateServerStr(dateReservation) + " " + this.reservation.HeureDebutAm),new Date(this.dateService.setToFormatDateServerStr(dateReservation) + " " + this.reservation.HeureFinAm),"","",null,false)
      if(this.ApMidiChecked)
        eventReservationPm = this.actionsService.createEvent(this.reservation,"",this.reservation.id + "_PM",new Date(this.dateService.setToFormatDateServerStr(dateReservation) + " " + this.reservation.HeureDebutPm),new Date(this.dateService.setToFormatDateServerStr(dateReservation) + " " + this.reservation.HeureFinPm),"","",null,false)
      
        listeEvent = listeEvent.filter(ev => {return ev.id != eventReservationAm.id &&  ev.id != eventReservationPm.id})
      
      if(eventReservationAm != undefined && this.actionsService.eventInclueInListeEvent(listeEvent,eventReservationAm))  
        disponible = false;
      if(eventReservationPm != undefined && this.actionsService.eventInclueInListeEvent(listeEvent,eventReservationPm))
        disponible = false;
    }
    return disponible;      
  }
  ChampEnterClient(event)
  {
    this.reservation.Tiers_code = event;
  }
  //get from server liste parametre heur
  getParamHeur()
  {
    this.generalService.rechercheTable(this.generalService.url + "avtHeureParam").subscribe(data => 
    {
      this.paramHeure = data[0];
      this.setTimeAmEtTimePm();
      if(this.generalService.isNotEmpty(this.paramHeure.avtHeure_Ecart))
      {
        if(this.paramHeure.avtHeure_Ecart.toString().length ==1)
          this.paramHeure.avtHeure_Ecart = "0" + this.paramHeure.avtHeure_Ecart;
      }
      this.showCalendarReservation = true;
      this.geteListeReservationByDate();
      this.reservation.HeureDebutAm = this.paramHeure.avtHeureAM_Deb;
      this.reservation.HeureFinAm = this.paramHeure.avtHeureAM_Fin;
      this.reservation.HeureDebutPm = this.paramHeure.avtHeurePM_Deb;
      this.reservation.HeureFinPm = this.paramHeure.avtHeurePM_Fin;
      this.MatinChecked = true;
      this.ApMidiChecked = true;
    })
  }

  //deffinir les liste de time (07:00, 07:15, 7:30...) pour le composons autocomplete
  setTimeAmEtTimePm()
  {
    this.timeAm = this.dateService.generateListeTime(this.paramHeure.avtHeureAM_Deb,this.paramHeure.avtHeureAM_Fin,this.paramHeure.avtHeure_Ecart)
    this.timePm = this.dateService.generateListeTime(this.paramHeure.avtHeurePM_Deb,this.paramHeure.avtHeurePM_Fin,this.paramHeure.avtHeure_Ecart)
    this.filterdTimeAm = this.timeAm.slice()
    this.filterdTimePm  = this.timePm.slice();
  }
  //se declenche apre que l'input name="HeureDebutPm" ou l'input name="HeureFinPm" perd le focus
  reservationHeurePMBlur(event,champ)
  {
    this.filterdTimePm = this.timePm.slice();
    event.target.value = this.dateService.setFormaTime(event.target.value);
    if(this.generalService.isNotEmpty(event.target.value) && this.filterdTimePm.length > 0 &&  this.filterdTimePm.find(time =>{return time == event.target.value}) == undefined)
    {
      event.target.value = this.filterdTimePm[0];
    }
    eval("this.reservation."+champ + " = '" + event.target.value + "'");
  }
  // se declenche on saisissant time reservation machine  de l'input name="HeureDebutPm" et l'input name="HeureFinPm" 
  reservationTimeChangePm(event) 
  {
    if(this.generalService.isNotEmpty(event.target.value))
    {
      this.filterdTimePm = this.timePm.filter((val) => 
      {
        return val.indexOf(event.target.value) >= 0;
      });
      if (this.filterdTimePm.length == 0) 
        event.target.value = event.target.value.substr(0, (event.target.value.length - 1));
    }
    else
      this.filterdTimePm = this.timePm.slice();
  }
  //se declenche apre que l'input name="HeureDebutAm" ou l'input name="HeureFinAm" perd le focus
  reservationHeureAMBlur(event,champ)
  {
    this.filterdTimeAm = this.timeAm.slice();
    event.target.value = this.dateService.setFormaTime(event.target.value);
    if(this.generalService.isNotEmpty(event.target.value) && this.filterdTimeAm.length > 0 &&  this.filterdTimeAm.find(time =>{return time == event.target.value}) == undefined)
    {
      event.target.value = this.filterdTimeAm[0];
    }
    eval("this.reservation."+champ + " = '" + event.target.value + "'");
  }
  // se declenche on saisissant time reservation machine de l'input name="HeureDebutAm" et l'input name="HeureFinAm" 
  reservationTimeChangeAm(event) 
  {
    if(this.generalService.isNotEmpty(event.target.value))
    {
      this.filterdTimeAm = this.timeAm.filter((val) => 
      {
        return val.indexOf(event.target.value) >= 0;
      });
      if (this.filterdTimeAm.length == 0) 
        event.target.value = event.target.value.substr(0, (event.target.value.length - 1));
    }
    else
      this.filterdTimeAm = this.timeAm.slice();
  }
  // affichier la semaine prochaine dans la calendrier
  nextDate()
  {
    this.calendarReservationComponent.calendarComponent.next();
    this.geteListeReservationByDate();
  }
  // affichier la semaine dernière dans la calendrier
  previewDate()
  {
    this.calendarReservationComponent.calendarComponent.prev();
    this.geteListeReservationByDate();
  }
  // affichier la semaine actuelle dans la calendrier
  now()
  {
    this.calendarReservationComponent.calendarComponent.gotoDate(new Date());
    this.geteListeReservationByDate();
  }
  onMatinChecked() 
  {
    if (!this.MatinChecked) {
      this.reservation.HeureDebutAm = null;
      this.reservation.HeureFinAm = null;
    }

  }
  onApMidiChecked() 
  {
    if (!this.ApMidiChecked) {
      this.reservation.HeureDebutPm = null;
      this.reservation.HeureFinPm = null;
    }
  }
  dateActionChange(peride)
  {
    if(peride == "DATEDEBUT")
    {
      if(this.generalService.isNotEmpty(this.reservation.DateFin))  
      {
        var debut = new Date(this.reservation.DateDebut )
        var fin = new Date(this.reservation.DateFin)
        if(debut.getTime() > fin.getTime())
        {
          this.reservation.DateDebut = this.generalService.clone(this.reservation.DateFin) ;
          this.generalService.dialogSuccess("La date de début doit etre inférieur à la date de fin",false);
        }
      }
      else
        this.reservation.DateFin = this.generalService.clone(this.reservation.DateDebut);
    }
    else if(peride == "DATEFIN")
    {
      if(this.reservation.DateDebut !=undefined &&this.reservation.DateDebut !=null)
      {
        var debut = new Date(this.reservation.DateDebut )
        var fin = new Date(this.reservation.DateFin)
        if(debut.getTime() > fin.getTime())
        {
          this.reservation.DateFin = this.generalService.clone(this.reservation.DateDebut);
          this.generalService.dialogSuccess("La date de fin doit etre inférieur à la date de bébut",false);
        }
      }
      else
        this.reservation.DateDebut = this.generalService.clone(this.reservation.DateFin);
    }
  
    
  }
  eventRender(event)
  {
    event.event.el.querySelector('.fc-title').innerHTML = event.event.event.title;
  }
  actionCalendar(event)
  {
    switch (event.acton)
    {
      case "eventRender":
          this.eventRender(event);
      break;
    }
    
  }
}
